import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import 'datatables.net-rowgroup-dt/css/rowGroup.dataTables.min.css'

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import { donationTypeExtraction } from '../../../libs/services';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

require( 'datatables.net-rowgroup-dt/js/rowGroup.dataTables.min');

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');
var report = require('../../generics/report_head');

class ComponentsObtained extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);
		this.getConvokePlace = this.getConvokePlace.bind(this);
		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.state = {
			health_facilities_id:"",
			health_facilities: [],

			extraction_type_id:"all",
			extraction_type:[],
			extraction_name:"",
			
			start_date 	: "",
			end_date 	: "",
		
			convoke_places:[],
			convoke_places_id:"all",
			convoke_places_name:"",

			component_type:"all",
			components:[],

			table_list:[],
			listado:[],

			change_check: false,

			columns:[
				{title:''},
				{title:'COMPONENTE'},
				{title:'A+'},
				{title:'A-'},
				{title:'B+'},
				{title:'B-'},
				{title:'O+'},
				{title:'O-'},
				{title:'AB+'},
				{title:'AB-'},
				{title:'Sin Grupo'},
				{title:'TOTAL'}
			],
			filename: "Componentes Obtenidos",
			listado_pdf:[],
			totals:[],
			date_hour:"",
			medical:"",
			format:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	async componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)

		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		this.getConvokePlace();

		let aux_resp = await donationTypeExtraction("no_cells");
        if(aux_resp !== undefined){
            this.setState({
                extraction_type: aux_resp
            });
        }

		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					components: response
				});
			}
		});

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.$el = $(this.el);
		
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});

                		doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
                		
                		doc.content.splice(3, 0, {
							columns:[
								this.state.convoke_places_id !== "all" ?
									{text: 'Lugar de Colecta', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.convoke_places_id !== "all" ?
									{text: this.state.convoke_places_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.extraction_type_id !== "all" ?
									{text: 'Extracción', width:'8%', fontSize:6.5}
								: {text:"", width:0},
								this.state.extraction_type_id !== "all" ?
									{text: this.state.extraction_type_name, bold:1, margin:[0,0,0,10], fontSize:6.5}
								: {text:"", width:0},
							]
						});

            			doc.defaultStyle.fontSize = 6; 
                		doc.styles.tableHeader.fontSize = 7;
                		
                		var head = []
						this.state.columns.map((c, i)=>{
							if(i > 0){
								head.push({text:c.title, style:'tableHeader', alignment: i > 1 ? 'right' : 'center'})
							}
							
						})

						this.state.listado_pdf.unshift(head);
						var tot = [];
						this.state.totals.map((t, i)=>(
            				tot.push({text:t, alignment:i===0? 'right':'right',bold:1})
            			))
            			this.state.listado_pdf.push(tot);
                		doc.content[4].table.body = this.state.listado_pdf;

                		doc.content[4].table.widths=["45%","5%","5%","5%","5%","5%","5%","5%","5%","5%","10%"];
                		
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            ],
            rowGroup: {
	            dataSrc: [ 0 ],
	            startRender: function ( rows, group ) {
	            	var total = rows
	                    .data()
	                    .pluck(11)[0]
	            	return $('<tr/>')
	                    .append( '<td colspan="10">'+group+'</td>' )
	                    .append( '<td style="text-align:right">'+total+'</td>' );
	            },
	        },
	        columnDefs: [ {
	            targets: [ 0 ],
	            visible: false
	        } ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
					"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
			ordering:true,
			createdRow: function(row, data, dataIndex){
				if(data[10] === ''){
					$(row).css('display', 'none');
				}

				if(data[1] === 'TOTAL'){
					$('td:eq(0)', row).attr('style', 'text-align:right');
				}
				data.map((d, i)=>{
					if(i > 0){
						$('td:eq('+i+')', row).attr('style', 'text-align:right');
					}
					
				})

            }
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}

		$('table thead tr').each(function(i){
			$(this).children('th').each(function(j){
				if(j > 0 && i === 0){
					$(this).attr('style', 'text-align:right');
				}
				
			})
		})
		
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});			

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

		if(e.target.name === 'health_facilities_id'){
			setTimeout(()=>{
				this.getConvokePlace();
			}, 500);		
		}

		if(e.target.name === 'search_type'){
			if(e.target.value === 'date'){
				this.setState({
					start_folio: "",
					end_folio: ""
				});
			}else{
				this.setState({
					start_date 	: "",
					end_date 	: ""
				});
			}
		}else if(e.target.name === 'convoke_places_id'){
			this.setState({
				convoke_places_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'extraction_type_id'){
			this.setState({
				extraction_type_name: e.target.options[e.target.selectedIndex].text
			})
		}
	}

	searching(){

		if(this.isValidForm()){
			if(this.dateCompare()){
				this.props.waiting.handleShow('Buscando...');

				var obj = {
					convoke_places_id: this.state.convoke_places_id,
					start_date: this.state.start_date,
					end_date: this.state.end_date,
					extraction_type_id: this.state.format === 'EXTRACTION' ? this.state.extraction_type_id : 'all',
					health_facilities_id:this.state.health_facilities_id,
					component_type: this.state.format === 'EXTRACTION' ? 'all' : this.state.component_type,
					format:this.state.format,
				}
			
				fetch(Config.default.apiGateway.URL+'reports/obtained_components',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							listado: [],
						});

						var list = [], list_pdf = [];

						if(this.state.format === 'EXTRACTION'){
							response.ext_types.forEach((ext)=>{
								var obj = [
									ext.type === 'CEL' ? 'CÉLULAS' :
									ext.type === 'ST' ? 'SANGRE TOTAL' : 'AFÉRESIS',
									ext.type === 'CEL' ? 'CÉLULAS' :
									ext.type === 'ST' ? 'SANGRE TOTAL' : 'AFÉRESIS'
								];
								var obj_pdf = [{
									text: ext.type === 'CEL' ? 'CÉLULAS' : ext.type === 'ST' ? 'SANGRE TOTAL' : 'AFÉRESIS',
									colSpan:10, bold:1, fillColor:'#f0f0f0'
								}];

								var total_row = 0;

								ext.totals.forEach((tot)=>{
									total_row += tot.total;
								})

								this.state.columns.forEach((col, i)=>{
									if(i > 1 && i < this.state.columns.length - 1){
										obj.push('');
										obj_pdf.push({});
									}else if(i === this.state.columns.length - 1){
										obj.push(total_row);	
										obj_pdf.push({text:total_row, bold:1, fillColor:'#f0f0f0', alignment:'right'});	
									}
								});

								list.push(obj);
								list_pdf.push(obj_pdf);

								

								ext.totals.forEach((tot)=>{
									obj = [
										ext.type === 'CEL' ? 'CÉLULAS' :
										ext.type === 'ST' ? 'SANGRE TOTAL' : 'AFÉRESIS'
									]; 
									obj_pdf = [];
									obj.push(tot.component);
									obj_pdf.push({text:tot.component, margin:[20,0,0,0]});

									this.state.columns.forEach((col, i)=>{
										if(i > 1 && i < this.state.columns.length - 1){
											var index = tot.groups.findIndex(obj => obj.text === col.title);

											if(index !== -1){
												obj.push(tot.groups[index].num)
												obj_pdf.push({text:tot.groups[index].num, alignment: 'right'})
											}else{
												if(col.title === 'Sin Grupo'){
													index = tot.groups.findIndex(item => item.text === '@@');
	
													if(index !== -1){
														obj.push(tot.groups[index].num)
														obj_pdf.push({text:tot.groups[index].num, alignment: 'right'})		
													}else{
														obj.push(0)
														obj_pdf.push({text:'0', alignment: 'right'})
													}
												}else{
													obj.push(0)
													obj_pdf.push({text:'0', alignment: 'right'})
												}
													
											}
										}
									});
									obj.push(tot.total);
									obj_pdf.push({text:tot.total, alignment:'right'});
									list.push(obj);
									list_pdf.push(obj_pdf);
								})
								
							})

						}else{
							response.types.map((res)=>{
								list.push([res.type,res.type,'','','','','','','','','',res.total]);
								
								list_pdf.push([
									{text:res.type, colSpan:10, bold:1, fillColor:'#f0f0f0'},{},{},{},{},{},{},{},{},{},
									{text:res.total, bold:1, fillColor:'#f0f0f0', alignment:'right'}
								])

								res.components.map((s)=>{
									var obj = [], obj_pdf = [];
									obj.push(res.type, s.component);
									obj_pdf.push({text:s.component, margin: [20,0,0,0]});

									this.state.columns.map((c, i)=>{
										if(i > 1 && i < 11){
											var index = s.groups.findIndex(obj => obj.text === c.title);
											if(index !== -1){
												obj.push(s.groups[index].num)
												obj_pdf.push({text:s.groups[index].num, alignment: 'right'})
											}else{
												if(c.title === 'Sin Grupo'){
													index = s.groups.findIndex(item => item.text === '@@');

													if(index !== -1){
														obj.push(s.groups[index].num)
														obj_pdf.push({text:s.groups[index].num, alignment: 'right'})		
													}else{
														obj.push(0)
														//obj.push('')
														obj_pdf.push({text:'0', alignment: 'right'})
													}
												}else{
													obj.push(0)
													//obj.push('')
													obj_pdf.push({text:'0', alignment: 'right'})
												}
													
											}
										}
											
									})

									obj.push(s.total)
									obj_pdf.push({text:s.total, alignment: 'right'})

									list.push(obj)
									list_pdf.push(obj_pdf)
								})

								var tot = [res.type,'TOTAL'];
								var obj_pdf = [];
								obj_pdf.push({text:'TOTAL', margin: [60,0,0,0]});
								this.state.columns.map((c, i)=>{
									if(i>1){
										var index = res.totals.findIndex(obj => obj.text === c.title);

										if(index !== -1){
											tot.push(res.totals[index].num);
											obj_pdf.push({text:res.totals[index].num, alignment: 'right'})
										}else{
											if(c.title === 'Sin Grupo'){
												index = res.totals.findIndex(item => item.text === '@@');

												if(index !== -1){
													tot.push(res.totals[index].num)
													obj_pdf.push({text:res.totals[index].num, alignment: 'right'})
												}else{
													tot.push('0')
													obj_pdf.push({text:'0', alignment: 'right'})
												}
											}else if(c.title === 'TOTAL'){
												tot.push(res.total);
												obj_pdf.push({text:res.total, alignment: 'right'})
											}else{
												tot.push('0');
												obj_pdf.push({text:'0', alignment: 'right'})
											}
										}
									}
									
								})

								list.push(tot)
								list_pdf.push(obj_pdf)

							})

						}

						var tot = ['TOTAL'];
						this.state.columns.map((c, i)=>{
							if(i>1){
								var index = response.totals.findIndex(obj => obj.text === c.title);

								if(index !== -1){
									tot.push(response.totals[index].num);
									
								}else{
									if(c.title === 'Sin Grupo'){
										index = response.totals.findIndex(item => item.text === '@@');

										if(index !== -1){
											tot.push(response.totals[index].num)	
										}else{
											tot.push('0')
										}
									}else if(c.title === 'TOTAL'){
										tot.push(response.total);
									}else{
										tot.push('0');
									}
								}
							}
							
						})

						this.setState({
							listado: list,
							listado_pdf:list_pdf,
							totals:tot
						});

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
					
							
						this.props.waiting.handleClose();
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}

 	getConvokePlace(){
 		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
 	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Procesado ->
					{this.state.filename}
					</h5>
				</div>
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span>
								</div>
								<div className="form-group">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>
								
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
								
								<div className="form-group">
									<span className="span-min">Formato</span>
									<select className="form-control" name="format" id="format"
										value={this.state.format} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="EXTRACTION">Tipo de Extracción</option>
										<option value="COMPONENT_TYPE">Tipo de Componente</option>
									</select>
								</div>

								{this.state.format === 'EXTRACTION' ?
									<div className="form-group">
										<span className="span-min">Tipo de Extracción</span>
										<select className="form-control" name="extraction_type_id" id="extraction_type_id"
											value={this.state.extraction_type_id} onChange={this.handleChange} required>
											<option value="">Seleccione...</option>
											<option value="all">TODOS</option>
											{this.state.extraction_type.map((don, i)=>{
												return <option key={i} value={don.id}>
													{don.donation_type_process}
												</option>
											})}
										</select>
									</div>
								:this.state.format === 'COMPONENT_TYPE' ?
									<div className="form-group">
										<span className="span-min">Tipo de Componente</span>
										<select className="form-control" name="component_type" id="component_type"
											value={this.state.component_type} onChange={this.handleChange} required>
											<option value="">Seleccione...</option>
											<option value="all">TODOS</option>
											{this.state.components.map((c, i)=>{
												return <option key={i} value={c.key}>
													{c.name}
												</option>
											})}
										</select>
									</div>
								:null}
									

								
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12 form-group">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									
									<div className="col-xs-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>
									
									<div className="col-xs-12">
										{this.state.convoke_places_id !== 'all' && this.state.convoke_places_id !== ""?
											<span>
												Lugar de Colecta:  
												<b style={{marginLeft:"5px"}}>{this.state.convoke_places_name}</b>
											</span>	
										:null}

										{this.state.extraction_type_id !== 'all' && this.state.extraction_type_id !== ""?
											<span style={{marginLeft:"15px"}}>
												Extracción: 
												<b style={{marginLeft:"5px"}}>{this.state.extraction_type_name}</b>
											</span>	
										:null}
									</div>
								</div>

								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} id="table-to-xls-align" 
											width="100%" ref={el => this.el = el}>
										</table>
									</div>

								</div>
								<div className="col-xs-12" style={{fontSize:"14px"}}>
									<table className="table">
										<tbody>
											<tr >
											{this.state.totals.map((t, i)=>{
												return <td key={i} style={
													i===0 ? {width:'28.5%', textAlign:'right', padding:'5px'} :
													i===2 || i===5? {width:'6.5%', textAlign:'right', padding:'5px'} : 
													i===7 || i===4 ? {width:'7%', textAlign:'right', padding:'5px'} :
													i===8 ? {width:'8.5%', textAlign:'right', padding:'5px'} :
													i===9 ? {width:'10%', textAlign:'right', padding:'5px'} :
													{width:'7.5%', textAlign:'right', padding:'5px'}}
												><b>{t}</b></td>											
											})}
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (ComponentsObtained);